module.exports = __webpack_public_path__ + "img/logo.9110b298.png";